var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"top-page-content"},[_c('rego-search'),_c('car-info')],1),_c('footer-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }